@if (transaction(); as transaction) {
  <div class="flex flex-col justify-between relative bg-aml-green-700 -mx-4 px-4 pt-3 min-h-screen menu-custom-scroll overflow-x-hidden">
    <div class="flex flex-col mb-3">
      <img class="mb-3 mt-5 mx-auto" ngSrc="assets/icons/cluster-transaction-in.svg" alt="out-transaction" height="60" width="60">
      <h3 class="relative px-[30px] !font-bold !text-[18px] leading-[1.2] mb-3 text-center text-white">
        @if (transaction.type === 'INCOMING') {
          Incoming
        } @else {
          Outgoing
        }
        Transaction Report
      </h3>
      <div class="gap-3 rounded-[6px] bg-black px-3 flex items-center justify-center mb-5">
        <div class="flex items-center gap-3">
          <mat-icon svgIcon="risk-severe" class="!w-[16px] !h-[17px]"></mat-icon>
          <mat-icon svgIcon="risk-severe" class="!w-[16px] !h-[17px]"></mat-icon>
          <mat-icon svgIcon="risk-severe" class="!w-[16px] !h-[17px]"></mat-icon>
        </div>
        <span class="text-[16px] text-white">Stolen Funds</span>
        <div class="flex items-center gap-3">
          <mat-icon svgIcon="risk-severe" class="!w-[16px] !h-[17px]"></mat-icon>
          <mat-icon svgIcon="risk-severe" class="!w-[16px] !h-[17px]"></mat-icon>
          <mat-icon svgIcon="risk-severe" class="!w-[16px] !h-[17px]"></mat-icon>
        </div>
      </div>
      <div class="flex justify-between items-center w-full mb-5">
        <span class="text-[10px] text-white leading-[1] font-bold uppercase min-w-fit max-w-fit w-full mr-1">AML Triggers</span>
        <span class="h-[1px] w-full bg-white"></span>
        @if (asIngoingTransaction(transaction); as ingoingTransaction) {
          @let triggerMoreOne = ingoingTransaction.latestAmlReport && ingoingTransaction.latestAmlReport.alerts && ingoingTransaction.latestAmlReport.alerts.length > 0;
          <button type="button" class="flex min-w-[14px] h-[14px] w-[14px] !p-0 ml-[4px] popover-hover-wrap relative" (click)="triggerMoreOne && isOpenTrigger.set(true); triggerMoreOne &&  variablesService.isHideScrollInSidebar.set(true)">
            <mat-icon class="!w-[14px] !h-[14px] !text-[14px] text-[#9AABAE]" svgIcon="tooltip-icon"></mat-icon>
          </button>
        }
      </div>
      <div class="mb-1 px-3">
        <p
          class="flex justify-between items-center min-h-[24px] !mb-0 text-[12px]">
          <span class="text-white/70">ID</span>
          <span class="text-white/70">{{ transaction.id }}</span>
        </p>
        <p
          class="flex justify-between items-center min-h-[24px] !mb-0 text-[12px]">
          <span class="text-white/70">Report Time</span>
          <span class="text-white/70">{{ transaction.timeCreated | date: 'HH:mm, dd/MM/yy' }}</span>
        </p>
      </div>

      <div class="bg-white flex flex-col rounded-[8px] shadow-3 border border-solid border-black mb-3">
        <div class="bg-[#F2F4F5] rounded-[6px] py-[9px] px-[11px] flex items-center">
          <img class="w-[30px] h-[30px] mr-[7px]"
              [src]="'assets/icons/currency/' + (transaction.coin | lowercase) + '.svg'" alt="">
          <div class="min-w-[38px] flex flex-col mr-3">
            <span class="leading-[1.2] text-[14px] font-bold mb-1">{{ transaction.coin }}</span>
            <span class="text-[11px] leading-[1.2] ">{{ transaction.network | convertNetworkToToken }}</span>
          </div>
          <div class="flex flex-col mr-3">
            <span class="text-[12px] leading-[1.2] mb-1 mt-[1px]">Sender:</span>
            <span class="flex items-center pt-[1px]">
              <span
                class="text-[#7A9095] text-[14px] leading-[1] mr-1">{{ transaction.addressFrom | cropWithDotsCenter: 6 : 6 }}</span>
              <app-copy-button [currentColor]="'text-[#7A9095] opacity-50'" [value]="transaction.addressFrom"
                              [size]="'small'"></app-copy-button>
            </span>
          </div>
        </div>
        <div class="flex justify-start py-3 pr-3 pl-4 bg-[#FFE5E5]">
          <img class="mr-[15px]" ngSrc="assets/icons/arrow-down-new.svg" alt="arrow" height="78" width="18">
          <div class="flex flex-col">
            <span class="text-[12px] leading-[1.2]">Amount Received:</span>
            <span class="leading-[1.2] text-[26px] tracking-[-0.45px] font-medium mb-2">
              @if (transaction.coin === 'USDT') {
                {{ (transaction.amount | cutNumber:('1.2-2')) ?? '0.00' }}
              } @else {
                {{ (transaction.amount | cutNumber:('1.2-8')) ?? '0.00' }}
              }
              {{ transaction.coin }}
            </span>
            <span class="text-[#7A9095] text-[12px] leading-[1.2] mb-[2px]">Hash:</span>
            <span class="flex items-center">
              <span
                class="text-[#7A9095] text-[14px] leading-[1]">{{ transaction.target | cropWithDotsCenter:14:14 }}</span>
              <app-copy-button [currentColor]="'text-[#7A9095] opacity-50'" class="ml-1" [value]="transaction.target"
                              [size]="'small'"></app-copy-button>
            </span>
          </div>
        </div>
        <div class="bg-[#F2F4F5] rounded-[6px] py-[9px] px-[11px] flex items-center">
          <img class="w-[30px] h-[30px] mr-[7px]"
              [src]="'assets/icons/currency/' + (transaction.coin | lowercase) + '.svg'" alt="">
          <div class="min-w-[38px] flex flex-col mr-3">
            <span class="leading-[1.2] text-[14px] font-bold mb-1">{{ transaction.coin }}</span>
            <span class="text-[11px] leading-[1.2] ">{{ transaction.network | convertNetworkToToken }}</span>
          </div>
          <div class="flex flex-col mr-3">
            <span class="flex text-[12px] leading-[1.2] mb-1 mt-[1px]">
              <span class="mr-3">Receiver:</span>
              @if (transaction.type === 'INCOMING') {
                <span class="font-bold">My wallet: {{ transaction.walletName }}</span>
              }
            </span>
            <span class="flex items-center pt-[1px]">
              <span
                class="text-[#7A9095] leading-[1] text-[14px] mr-1">{{ transaction.addressTo | cropWithDotsCenter:10:10 }}</span>
              <app-copy-button [currentColor]="'text-[#7A9095] opacity-50'" [value]="transaction.addressTo"
                              [size]="'small'"></app-copy-button>
            </span>
          </div>
        </div>
      </div>
      @if (asIngoingTransaction(transaction); as ingoingTransaction) {
        @if (ingoingTransaction.latestAmlReport.alerts) {
          <div class="flex flex-col mb-9 pl-[48px]">
            <h3 class="text-white text-[16px] leading-[1.25] font-bold mb-3">AML Triggers Exposure: {{typeExposure() ?? 'DIRECT'}}</h3>
            <span class="text-white/70 text-[12px] leading-[1.2]">Risk Amount:</span>
            <span class="text-white font-medium leading-[1.1] text-[26px]">{{ transaction.riskyAmount| cutNumber:('1.2-2') }} USDT</span>
          </div>
        }
      }
      <div class="flex flex-col">
        @if (transaction.leaCountry) {
          <div class="min-h-[36px] flex items-center justify-between border-y border-solid border-white/5">
            <div class="flex items-center">
              <span class="text-[16px] leading-[1.2] text-white/70">LEA:</span>
              <app-info class="w-[14px] h-[14px] ml-2" [currentColor]="'text-white/20'" [text]="'The LEA section identifies the investigating authority for the stolen funds incident.'"></app-info>
            </div>
            <div class="text-white text-[16px] leading-[1]">{{transaction.leaCountry}}</div>
          </div>
        }
        @if (transaction.victimCountry) {
          <div class="min-h-[36px] flex items-center justify-between border-b border-solid border-white/5">
            <div class="flex items-center">
              <span class="text-[16px] leading-[1.2] text-white/70">Victim’s country of residence</span>
              <app-info class="w-[14px] h-[14px] ml-2" [currentColor]="'text-white/20'" [text]="'This section specifies the victim\'s location.'"></app-info>
            </div>
            <div class="text-white text-[16px] leading-[1]">{{transaction.victimCountry}}</div>
          </div>
        }
        @if (transaction.accidentDate) {
          <div class="min-h-[36px] flex items-center justify-between border-b border-solid border-white/5">
            <div class="flex items-center">
              <span class="text-[16px] leading-[1.2] text-white/70">Date of accident</span>
              <app-info class="w-[14px] h-[14px] ml-2" [currentColor]="'text-white/20'" [text]="'This field shows only the exact date when the accident occurred.'"></app-info>
            </div>
            <div class="text-white text-[16px] leading-[1]">{{transaction.accidentDate | date: 'dd/MM/yy'}}</div>
          </div>
        }
        <div class="min-h-[36px] flex items-center justify-between border-b border-solid border-white/5">
          <div class="flex items-center">
            <span class="text-[16px] leading-[1.2] text-white/70">Description</span>
            <app-info class="w-[14px] h-[14px] ml-2" [currentColor]="'text-white/20'" [text]="'This shows whether a description of the case is provided.'"></app-info>
          </div>
          <mat-icon svgIcon="white-round-success" class="!w-[18px] !h-[18px]"></mat-icon>
        </div>
        <div class="min-h-[36px] flex items-center justify-between border-b border-solid border-white/5">
          <div class="flex items-center">
            <span class="text-[16px] leading-[1.2] text-white/70">Evidence</span>
            <app-info class="w-[14px] h-[14px] ml-2" [currentColor]="'text-white/20'" [text]="'This section explains if there is evidence attached to the case.'"></app-info>
          </div>
          <mat-icon svgIcon="white-round-success" class="!w-[18px] !h-[18px]"></mat-icon>
        </div>
      </div>
    </div>

    <div class="-mx-4 px-4 py-6 bg-[#1B4249] rounded-t-[9px]"
      [ngClass]="{'pb-[160px]': (
        transaction.nextIncidentProgressStep === 'TEMPORARY_FREEZE' && isComplianceRole() ||
        transaction.nextIncidentProgressStep === 'PERMANENT_FREEZE' && isComplianceRole() ||
        transaction.nextIncidentProgressStep === 'AWAITING_LEA_SUBMISSION' && userRole() === 'POLICE'
      )}"
    >
      <app-incident-progress (outputUpdateTransaction)="loadTransaction()" [transaction]="transaction"></app-incident-progress>
    </div>

    @if (isOpenTrigger()) {
      <div class="absolute w-[400px] right-0 top-0 bottom-0 z-30 bg-[#022D35]">
        <div class="flex items-center relative min-h-[54px] px-4 bg-[#022D35]">
          <h4 class="text-[18px] font-bold text-white">AML triggers</h4>
          <button (click)="isOpenTrigger.set(false); variablesService.isHideScrollInSidebar.set(false)" type="button" class="flex absolute right-[18px] top-[18px]">
            <mat-icon class="text-[#CCD2D9] !w-[18px] !h-[18px]" svgIcon="close"></mat-icon>
          </button>
        </div>
        <div class="bg-white w-full min-h-[calc(100vh-54px)] rounded-t-[8px] absolute top-[54px] right-0 py-6 px-5">
          @if (asIngoingTransaction(transaction); as ingoingTransaction) {
            @if (ingoingTransaction.latestAmlReport.alerts) {
              @for (alert of ingoingTransaction.latestAmlReport.alerts; track $index) {
                <div
                  class="flex justify-between items-start pb-[6px] mb-[6px] border-b border-solid border-black border-opacity-5 last:pb-0 last:mb-0">
                  <div class="flex flex-col items-start">
                    <span class="leading-[1.3] font-bold text-[#234542]">
                      {{ alert.categoryId | triggerIdConvertToCategory | titlecase }}
                    </span>
                    <span class="leading-[1.2] text-[11px] text-[#567474] mr-1 flex items-center">
                      <span class="mr-1">{{ alert.alertAmount | cutNumber:('1.2-2') }} USDT</span>
                      <span
                        class="text-[11px] font-medium text-[#45525B] rounded-[60px] bg-[#23454233] px-1 py-[2px]">{{ calcPercentForExposures(+alert.alertAmount) }}
                        %</span>
                    </span>
                    <span
                      class="uppercase text-[12px] font-medium rounded-[60px] min-h-[15px] px-[6px] flex justify-center items-center mb-1"
                      [ngClass]="{
                        'border border-solid border-[#C92F29] text-[#C92F29]': alert.exposureType === 'INDIRECT',
                        'bg-[#C92F29] text-white': alert.exposureType !== 'INDIRECT'
                      }"
                    >
                    {{ alert.exposureType | titlecase }}
                    </span>
                  </div>
                  <div>
                    <app-report-status [risk]="alert.alertLevel"></app-report-status>
                  </div>
                </div>
              }
            }
          }
        </div>
      </div>
    }
  </div>
}
